/**
 * Custom skeleton shimmer bar. The Cloudscape <Skeleton> component
 * (https://cloudscape.design/components/skeleton/) exists in our
 * @amzn/awsui-components-react@3.0.0 package folder but is a non-functional
 * stub that throws at runtime. A future version of the package will support it.
 * When it does, replace this component with:
 *   import Skeleton from '@amzn/awsui-components-react/polaris/skeleton';
 *   <Skeleton width="80px" height="14px" />
 *
 * Colors come from Cloudscape design tokens via the `.skeleton-bar` classes in
 * App.scss so the placeholder follows dark mode (previously hardcoded hex values
 * only worked in light mode).
 */
type SkeletonVariant = 'default' | 'label' | 'accent' | 'block';

export function SkeletonBar({
  width,
  height,
  variant = 'default',
}: {
  width: string;
  height: string;
  variant?: SkeletonVariant;
}) {
  const variantClass = variant === 'default' ? '' : ` skeleton-bar--${variant}`;
  return <div className={`skeleton-bar${variantClass}`} style={{ width, height }} />;
}
